export default __webpack_public_path__ + "static/media/dashboardWhite.c29a0d23.svg";